import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IconesModalComponent } from "../../../modals/icones-modal/icones-modal.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss']
})
export class IconPickerComponent implements OnInit {
  @Input() icone?: string;
  @Output() onChange = new EventEmitter<string | undefined>();

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  selecionarIcone() {
    const dialogRef = this.dialog.open(IconesModalComponent, {
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.icone = result;
        this.onChange.emit(this.icone);
      }
    });
  }

  excluirIcone() {
    this.icone = undefined;
    this.onChange.emit(this.icone);
  }
}
